import axios from "axios";
import loginAuth from "../../models/login/loginAuth";
const _3DES = require("nodejs3des");
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  loginAuth(data) {
    const url = this.config.apiUrl;
    const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");

    let payload = {
      email: data.email,
      password: _3DES.encrypt(dkey, data.password),
    };

    return axios.post(`${url}/login`, payload).then(({ data }) => {
      return loginAuth.fromJson(data);
    });
  }

  loginAD(data) {
    const url = this.config.apiUrl;
    const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");

    let payload = {
      email: data.email,
      password: _3DES.encrypt(dkey, data.password),
    };

    return axios.post(`${url}/login/ad`, payload).then(({ data }) => {
      return loginAuth.fromJson(data);
    });
  }

  loginWithOperId(query) {
    const url = this.config.apiUrl;
    const body = {
      operId: parseInt(query, 10),
    };
    return axios.post(`${url}/login/operid`, body).then(({ data }) => {
      return loginAuth.fromJson(data);
    });
  }

  //obtener version de la app
  getAppVersion() {
    const url = this.config.apiUrl;
    let token = localStorage.getItem("token");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/gitlablasttag`, { headers }).then(({ data }) => {
      return data; // Devuelve los datos sin modificar
    });
  }

  changepass(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = { ...data };
    delete payload.operId;
    if (payload.hasOwnProperty("newPassword")) {
      payload.newPassword = _3DES.encrypt(dkey, payload.newPassword);
    }
    return axios
      .patch(`${url}/changepass/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  forgotPass(data) {
    const url = this.config.apiUrl;
    const token = localStorage.getItem("token");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/forgotpass/${data.email}`, { headers });
  }

  avtiveTwoFactor() {
    const url = this.config.apiUrl;
    const operId = localStorage.getItem("operId");
    const token = localStorage.getItem("token");

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .post(`${url}/2fa/setup/${operId}`, {}, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  verifyTwoFactor(data) {
    const url = this.config.apiUrl;
    const operId = localStorage.getItem("operId");
    const token = localStorage.getItem("token");

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/2fa/verify/${operId}&${data}`, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  updateTwoFactor(data) {
    const url = this.config.apiUrl;
    let operId = localStorage.getItem("operId");
    const token = localStorage.getItem("token");

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = { active: data };

    return axios.patch(`${url}/2fa/activo/${operId}`, payload, { headers });
  }
}
export default service;
